import classNames from "classnames/bind";
import HomeBtn from "images/IPX/JourneyToDonut/ipx_donut_button_home_02.png";
import AgainBtn from "images/IPX/JourneyToDonut/ipx_donut_button_retry_02.png";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

function ResultButtons({onClickHome, onClickReplay}) {
  return (
    <div className={cn("options_buttons")}>
      <div className={cn("inner")}>
        <button className={cn("option")} type="button" onClick={onClickHome}>
          <img alt="home button" src={HomeBtn} />
        </button>
        <button className={cn("option")} type="button" onClick={onClickReplay}>
          <img alt="option btn" src={AgainBtn} />
        </button>
      </div>
    </div>
  );
}

export default ResultButtons;
